/*
Sohel 03/30/2023 2699762545 Change letter Type Value
Akhila 05/24/2024 2699762545 role access implemeneted
*/

// Sohel 03/30/2023 2699762545 Change letter Type Value
// Ravi 05/31/2023 2699762545 changed delete popup message
import React, {useState} from 'react';
import {Tooltip, IconButton} from '@material-ui/core';
import {DeleteOutlined} from '@material-ui/icons';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';

import {withField} from '../../../FrameWorks/DataManager/DataManagerRecord/AddDataManagerRecord/RecordFormatFieldsComponents/withField';

function GroupRecord(props) {
  const {
    value,
    index,
    values,
    key,
    priorArrayHelpers,
    lettersDeletedIds,
    setLettersDeletedIds,
    LetterMainAccess,
    editExisting,
  } = props;
  const [isDelete, setIsDelete] = useState(false);
  const handleClose = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () => {
    priorArrayHelpers.current.remove(index);
    if (values?.priorLetters[index]?.precedingLetterId) {
      const ids = [...lettersDeletedIds, values?.priorLetters[index]?.precedingLetterId];
      setLettersDeletedIds(ids);
    }
    setIsDelete(false);
  };

  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center">
          <Tooltip title="Delete">
            <IconButton
              disabled={editExisting && !LetterMainAccess?.edit}
              onClick={() => setIsDelete(true)}
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>
        <td className="recFormat-col global-field-textfields">{value.letterCode}</td>
        <td className="recFormat-col global-field-textfields">{value.letterDescription}</td>
      </tr>

      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Prerequisite"
        value={`Are you sure you want to delete the ${value?.letterCode} Prerequisite?`}
        handleSubmit={handleConfirmDelete}
      />
    </>
  );
}
export default withField(GroupRecord);
